<template>
    <widget-temp :widgetTitle="'Thống kê doanh thu tháng ' + currrentMonth" widgetName="OrderStatistic" v-bind:widgetId="1">
        <template slot="widget-content">
            <v-layout row wrap ma-2>
                <v-flex lg12 md12 sm12>
                    <v-layout row wrap ml-1>
                        <v-flex lg6 md6 sm12>
                            <p>Số lượng đơn hàng trong tháng: <b class="red--text">{{ total_order | currency }}</b></p>
                            <p>Số đơn hàng khách mới trong tháng: <b class="red--text">{{ (total_order_type1 + total_deposit_type1) | currency }}</b></p>
                            <p>Số đơn hàng ký gửi trong tháng: <b class="red--text">{{ total_deposit | currency }}</b></p>
                        </v-flex>
                        <v-flex lg6 md6 sm12>
                            <p>Doanh thu khách (0-60 ngày): <b class="red--text">{{ rev_by_type1 | currency }}</b></p>
                            <p>Doanh thu khách (61-240 ngày): <b class="red--text">{{ rev_by_type2 | currency }}</b></p>
                            <p>Doanh thu khách (trên 240 ngày): <b class="red--text">{{ rev_by_type3 | currency }}</b></p>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex lg6 md6 sm12>
                    <p class="ml-1 mt-2"><b>Doanh thu khách (0-60 ngày) trong tháng của bạn: <span class="red--text">{{ (rev_summary ? rev_summary.Amount : 0) | currency }}</span></b></p>
                    <v-card class="ma-1">
                        <v-data-table :headers="sale_headers" :items="top_sale" :server-items-length="top_sale ? top_sale.length : 0" disable-pagination hide-default-footer>
                            <template v-slot:item="{ item, index }">
                                <tr>
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ item.Username }}</td>
                                    <td class="text-end">{{ item.Amount | currency }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
                <v-flex lg6 md6 sm12>
                    <p class="ml-1 mt-2"><b>Top 10 khách hàng có nhiều đơn trong tháng</b></p>
                    <v-card class="ma-1">
                        <v-data-table :headers="top10_headers" :items="top10_customer" :server-items-length="top10_customer ? top10_customer.length : 0" :must-sort="true" :loading="loading" :mobile-breakpoint="100" disable-pagination hide-default-footer>
                            <template v-slot:item="{ item, index }">
                                <tr>
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ item.Username }}</td>
                                    <td class="text-end">{{ item.Amount | currency }}</td>
                                    <td class="text-end">{{ item.TotalOrder | currency }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
                <v-flex lg12 md12 sm12 v-if="!saleRole">
                    <v-card class="ma-1">
                        <v-data-table :headers="revenue_headers" :items="rev_items" :options.sync="pagination" :server-items-length="total_rev_items" :footer-props="items_per_page" :mobile-breakpoint="100">
                            <template v-slot:item="{ item, index }">
                                <tr>
                                    <td>{{ (pagination.page - 1) * pagination.itemsPerPage + index + 1 }}</td>
                                    <td>{{ item.Username }}</td>
                                    <td class="text-end">{{ item.Wallet | currency }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
            </v-layout>
        </template>
    </widget-temp>
</template>
<script>
import { mapState } from "vuex";
import configs from "@/configs";
import moment from "moment";
export default {
    name: "order-statistic",
    data() {
        return {
            listStatus: configs.ORDER_STATUS,
            revenue_headers: [
                {
                    text: "STT"
                },
                {
                    text: "Khách hàng",
                    value: "Username",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Dư ví",
                    value: "Wallet",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                }],
            sale_headers: [
                {
                    text: "STT"
                },
                {
                    text: "Sale",
                    value: "Username",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Doanh thu",
                    value: "Amount",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                }],
            top10_headers: [
                {
                    text: "STT"
                },
                {
                    text: "Khách hàng",
                    value: "Username",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Doanh thu",
                    value: "Amount",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng đơn",
                    value: "Amount",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                }],
            dateRange: {
                startDate: moment
                .utc(Date.now())
                .startOf("month")
                .toISOString()
                .substr(0, 10),
                endDate: moment
                .utc(Date.now())
                .endOf("month")
                .toISOString()
                .substr(0, 10)
            },
            currrentMonth: moment.utc(Date.now()).format("MM-YYYY"),
            pagination: { ...configs.PAGINATION, sortBy: ["Wallet"], itemsPerPage: 10},
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
        }
    },
    watch: {
        pagination: {
            handler: function(val, oldVal) {
                this.getChartData();
            },
            deep: true
        },
    },
    computed: {
        ...mapState({
            rev_items: state => state.report.saleReport.rev_items,
            total_rev_items: state => state.report.saleReport.total_rev_items,
            rev_summary: state => state.report.saleReport.rev_summary,
            top_sale: state => state.report.saleReport.top_sale,
            top10_customer: state => state.report.saleReport.top10_customer,
            rev_by_type: state => state.report.saleReport.rev_by_type,
            total_by_type: state => state.report.saleReport.total_by_type,
            loading: state => state.report.loading,
        }),
        saleRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Sale) == configs.ROLE_TYPE.Sale;
        },
        rev_by_type1() {
            const p = _.find(this.rev_by_type, {ReportType: 1});
            return p ? p.Amount : 0;
        },
        rev_by_type2() {
            const p = _.find(this.rev_by_type, {ReportType: 2});
            return p ? p.Amount : 0;
        },
        rev_by_type3() {
            const p = _.find(this.rev_by_type, {ReportType: 3});
            return p ? p.Amount : 0;
        },
        total_order() {
            const p = _.filter(this.total_by_type, {OrderType: 1});
            return _.sumBy(p, 'TotalOrder');
        },
        total_order_type1() {
            const p = _.filter(this.total_by_type, {OrderType: 1, ReportType: 1});
            return _.sumBy(p, 'TotalOrder');
        },
        total_deposit() {
            const p = _.filter(this.total_by_type, {OrderType: 2});
            return _.sumBy(p, 'TotalOrder');
        },
        total_deposit_type1() {
            const p = _.filter(this.total_by_type, {OrderType: 2, ReportType: 1});
            return _.sumBy(p, 'TotalOrder');
        }
    },
    methods: {
        getChartData: _.debounce(function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions,
                startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
                endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT),
            };
            this.$store.dispatch("report/getSaleDashboardReport", param);
            }, 300, {
                'leading': true,
                'trailing': false
        }),
    },
    mounted: function () {
        this.getChartData();
    }
};
</script>
  
<style  lang="scss" scoped>
.btn {
    display: inline-block;
    margin-bottom: 0;
    font-weight: normal;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid transparent;
    white-space: nowrap;
    padding: 10px 12px;
    font-size: 12px;
    line-height: 1.42857143;
    border-radius: 2px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.btn-default {
    color: #000000;
    background-color: #ffffff;
    border-color: #bdc3d1;
    text-decoration: none;
}

.btn-status {
    height: 87px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-left: 3px solid;
}

.btn-sm,
.btn-group-sm>.btn {
    padding: 5px 8px;
    font-size: 11px;
    line-height: 1.5;
    border-radius: 2px;
}

.btn-block {
    width: 100%;
}

.btn-default:hover {
    color: #696c74;
    background-color: #ededed;
    border-color: #9fa8bc;
}

.btn-sm,
.btn-group-sm>.btn {
    padding: 5px 8px 4px;
}

.btn-order-status {
    border-left: 3px solid;
    margin-bottom: 3px;

    span {
        float: right;
        text-align: right;
        border-left: 1px solid;
        border-color: #bdc3d1;
        width: 15%;
        height: 100%;
    }
}

.btn-m-status {
    border-left: 3px solid;
}

.group-box-mb {
    display: none;

    .group-status {
        width: 100%;
        background: #fff;
        border: 1px solid #d8dce3;
        box-shadow: none;

        .btn-toggle {
            width: 100%;
            color: #696c74;
        }

        .dropdown-menu {
            width: 100%;
        }
    }
}

.active-status {
    color: #ffffff;
    background-color: #3b4354;
    border-color: #3b4354;

    a:hover {
        color: #ffffff;
        background-color: #3b4354;
        border-color: #3b4354;
    }

    a {
        color: #ffffff;
    }
}

.divider {
    margin: 0px 0px;
}

.filter-text-box {
    margin-top: 15px;
    margin-bottom: 0px;

    .form-control {
        border: 0px;
        border-bottom: 1px solid #bdc3d1;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
    }
}

.muuri-item {
    min-height: 0 !important;
    height: 200px !important;
}

@media (max-width: 992px) {
    .group-box-mb {
        display: block;
    }

    .group-box {
        display: none;
    }
}

@media (max-width: 686px) {
    .widget-block .content-widget .performance-block .title-stt {
        font-size: 14px;
        line-height: 1.2;
    }

    .widget-block .content-widget .performance-block .num {
        font-size: 28px;
    }
}

@media (max-width: 500px) {

    .widget-block .content-widget .performance-block .col.col-4,
    .widget-block .content-widget .performance-block .col.col-8 {
        width: 100%;
        max-width: 100%;
        flex: 0 0 100%;
    }

    .widget-block .content-widget .performance-block .div-table.height-2 {
        height: 150px !important;
    }
}

.widget-block .content-widget .stt-block {
    margin-bottom: 10px;
}

.performance-block .col>.col {
    padding: 0;
}

.performance-block .col>.col>.col {
    padding: 0;
}

.performance-block .row {
    margin: 0px;
}

.performance-block .col {
    padding: 0px;
}</style>